import React from "react";
import UpdateWall from "./UpdateWall";
import { useParams } from "react-router-dom";

export function DisplayWall(props) {
    const param = useParams();
    return <UpdateWall param={param} {...props} />
}
